import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CatPromotionSchema } from 'src/app/model/promotion-models';
import { CommissionPromotionsService } from 'src/app/services/commission-promotions.service';
import { ModalNewPromotionComponent } from 'src/app/shared/modal-new-promotion/modal-new-promotion.component';

@Component({
  selector: "app-commission-cat-promotions",
  templateUrl: "./commission-cat-promotions.component.html",
  styleUrls: ["./commission-cat-promotions.component.css"],
})
export class CommissionCatPromotionsComponent implements OnInit {
  public viewStatus = 0; // -1:nada, 0:spinner, 1:tabla
  public promotionSchemasList: CatPromotionSchema[] = [];

  constructor(
    private modalService: NgbModal,
    private commissionPromotionsService: CommissionPromotionsService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.getCatalogs();
  }

  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [{ responsivePriority: 1, width: 100, targets: -1 }],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ["csv", "excel"],
    autoWidth: false,
    // pagingType: 'full_numbers',
    paging: true,
    pageLength: 100,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
      // dom: 'Bfrtip',
      buttons: ["excel"],
    },
  };

  add = () => {
    let modalRef = this.modalService.open(ModalNewPromotionComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.mode = "create";
    modalRef.result.then(
      (data) => console.log("Data: ", data),
      (reason: string) => {
        console.log("Reason: ", reason);
        if (
          reason !== "cancel" &&
          reason !== "error" &&
          reason !== "failure"
        ) {
          this.viewStatus = 0;
          // this.getCatalogs();
        }
      }
    );
  };

  // getCatalogs = () => {

  //   this.commissionPromotionsService.getCatalogPromotionSchemas()
  //     .subscribe(
  //       (response) => {
  //         this.promotionSchemasList = response.data;
  //         console.log(this.promotionSchemasList);
  //         this.viewStatus = 1;
  //       },
  //       (error) => {
  //         this.viewStatus = -1;
  //         this.toastr.error("Ocurrió un error al leer el catálogo de promociones.");
  //         console.log(error);
  //       }
  //     );
  // };
}
